import React, { useEffect, useState } from "react";
import { CardBody, CardContainer, CardFooter, CardHeader, InfoCard } from "best-common-react";
import GlobalProtected from "../../components/protected/GlobalProtected";
import EventDataCard from "../../components/events/EventDataCard";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import ComptixAssignedAccountInformation from "../../components/ticketmaster/ComptixAssignedAccountInformation";
import EventMappings from "../../components/ticketmaster/EventMappings";
import CustomerIdSearch from "../../components/ticketmaster/CustomerIdSearch";
import TicketmasterSearchParams from "../../components/ticketmaster/TicketmasterSearchParams";
import TicketmasterSearchResults from "../../components/ticketmaster/TicketmasterSearchResults";

function TicketmasterDebuggerContainer(props) {
  const { compTixApi } = props.rootStore;

  const [currentGame, setCurrentGame] = useState(null);
  const [dsn, setDsn] = useState(null);
  const [mappings, setMappings] = useState([]);
  const [results, setResults] = useState([]);
  const [accounts, setAccounts] = useState(null);

  useEffect(() => {
    // get game from comptix api
    compTixApi.getEventInformation(props.match.params.gamePk).then(f => {
      setCurrentGame(f);
    });
  }, [props.match.params.gamePk]);

  useEffect(() => {
    if (currentGame) {
      compTixApi.getDsn(currentGame.venue.id).then(f => {
        setDsn(f);
      });

      compTixApi.getAllEventMappings(currentGame.teams.home.team.id, currentGame.gamePk).then(f => {
        setMappings(f);
      });

      compTixApi.getAccountInfo(currentGame.gamePk).then(f => {
        setAccounts(f);
      });
    }
  }, [currentGame]);

  if (currentGame == null) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <CardContainer>
        <CardHeader>Ticketmaster</CardHeader>
        <CardBody>
          <div className="d-flex flex-row">
            <div className="d-flex flex-column col-6">
              {currentGame.gamePk && <EventDataCard game={currentGame} eventId={currentGame.gamePk} />}
            </div>
            <div className="d-flex flex-column col-6">
              <div>
                <ComptixAssignedAccountInformation dsn={dsn} accounts={accounts} />
                <CustomerIdSearch dsn={dsn} compTixApi={compTixApi} />
              </div>
            </div>
          </div>
          <div className="d-flex flex-row">
            <div className="d-flex flex-column col-6">
              <p>
                Please ensure that all event type and sub type pairings are unique. Pay particular attention to
                Standard/Fixed mappings.
              </p>
              <EventMappings mappings={mappings} />
            </div>
            <div className="d-flex flex-column col-6 mt-4">
              <InfoCard title="Ticket Search">
                <TicketmasterSearchParams
                  compTixApi={compTixApi}
                  accounts={accounts}
                  dsn={dsn}
                  gamePk={currentGame.gamePk}
                  homeTeamId={currentGame.teams.home.team.id}
                  onSearch={setResults}
                />
                <TicketmasterSearchResults results={results} />
              </InfoCard>
            </div>
          </div>
        </CardBody>
      </CardContainer>
    </div>
  );
}

export default GlobalProtected(TicketmasterDebuggerContainer);
